"use client";
import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./Speciallization_Key_Feature.css";
import Main_heading_holder from "../../common_components/common_css/main_heading_holder/Main_heading_holder"

// Swiper imports
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

// Swiper styles
import "swiper/css";
import "swiper/css/pagination";

const Speciallization_Key_Feature = ({ id, spanHeadingColor, bgColor }) => {
  const features = [
    {
      title: "Strategic Thinking",
      img: "https://node.profcyma.com/public/upload/Ed_Tech/university/common_university_key_program_features/1766992485530-strategising.png",
      desc: "Develop workplace strategies that effectively integrate people, processes, and technology to create sustainable business ecosystems.",
    },
    {
      title: "Leadership Excellence",
      img: "https://node.profcyma.com/public/upload/Ed_Tech/university/common_university_key_program_features/1766992449735-Leadership.png",
      desc: "Learn to lead modern teams by optimising talent and technology to drive collaboration and organisational growth.",
    },
    {
      title: "Data-Driven Analysis",
      img: "https://node.profcyma.com/public/upload/Ed_Tech/university/common_university_key_program_features/1766992291631-Analysis.png",
      desc: "Build the ability to critically analyse data and transform insights into informed, tactical business decisions.",
    },
    {
      title: "Influence & Communication",
      img: "https://node.profcyma.com/public/upload/Ed_Tech/university/common_university_key_program_features/1766992374455-Influencing.png",
      desc: "Master communication and negotiation skills to lead change and understand the role of influence in decision-making.",
    },
    {
      title: "Structured Problem Solving",
      img: "https://node.profcyma.com/public/upload/Ed_Tech/university/common_university_key_program_features/1766992545366-Systematic.png",
      desc: "Strengthen your problem-solving abilities through real-world projects focused on research, analysis, and actionable insights.",
    },
  ];

  return (
    <section className="key-program">
      <Container>
        
        {/* Heading */}
           <Main_heading_holder
              heading={" Key Program "}
              spanHeading={" Features"}
              subHeading={
                " Engaging, stimulating—learning that enriches your  educational journey profoundly."
              }
              spanHeadingColor={spanHeadingColor}
            />

        {/* Cards */}

         <div className="row">
           <Swiper
                spaceBetween={15}
                pagination={{
                  clickable: true,
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1.2,
                  },
                  486: {
                    slidesPerView: 1.5,
                  },
                  500: {
                    slidesPerView: 1.8,
                  },
                  578: {
                    slidesPerView: 2,
                  },
                  768: {
                    slidesPerView: 2.5,
                  },
                  991: {
                    slidesPerView: 3,
                  },
                  1024: {
                    slidesPerView: 3,
                  },
                  1200: {
                    slidesPerView: 4,
                  },
                  1400: {
                    slidesPerView: 5,
                  },
                  1600: {
                    slidesPerView: 5,
                  },
                }}
                modules={[Pagination]}
                className="mySwiper"
              >
          {features.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="icon-box">
                
                <div className="image_holder">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="inner_img"
                  />
                </div>

                <h4 className="title">{item.title}</h4>
                <p className="description">{item.desc}</p>

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
          </div>

      </Container>
    </section>
  );
};

export default Speciallization_Key_Feature;